import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { SPECIAL_OFFER_ROUTES } from 'src/app/core/constants/routes-constants';
import { NotificationService } from 'src/app/core/services/notification.service';
import { SPECIAL_OFFER_CLIENT_STATUS } from 'src/app/extensions/constants/commonConstants';
import { SpecialOfferAPIService } from 'src/app/extensions/services/api/specialOffer-api.service';
import { CountdownService } from 'src/app/extensions/services/countdown-service.service';

@Component({
  selector: 'preview-information',
  standalone: false,
  templateUrl: './preview-information.component.html',
  styleUrl: './preview-information.component.scss',
})
export class PreviewInformationComponent implements OnChanges {
  @Input() specialOffer: app.models.GetSpecialOfferClientModel;
  countdown$: Observable<string> = of('');
  SPECIAL_OFFER_STATUS = SPECIAL_OFFER_CLIENT_STATUS;

  constructor(
    private _countdownService: CountdownService,
    private _specialOfferAPIService: SpecialOfferAPIService,
    private _notificationService: NotificationService,
    private _translateService: TranslateService,
    private _router: Router
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.specialOffer && this.specialOffer.expireAt) {
      this.countdown$ = this._countdownService.getCountdown(new Date(this.specialOffer.expireAt));
    }
  }

  sendOfferRequest(specialOfferId) {
    this._specialOfferAPIService.requestSpecialOffer(specialOfferId).subscribe(result => {
      if (result.isSuccess) {
        this._notificationService.showSuccess(
          this._translateService.instant('specialOffers.wizard.notification.requestSaved'),
          this._translateService.instant('common.success')
        );

        this._router.navigate([SPECIAL_OFFER_ROUTES.SPECIAL_OFFERS, SPECIAL_OFFER_ROUTES.SPECIAL_OFFER_REQUESTED]);
      }
    });
  }
}
